import React, { useState, useContext, useEffect } from 'react';
import { NextSeo } from 'next-seo';
import safeJsonStringify from 'safe-json-stringify';
import { useRouter } from 'next/router';
import { Box } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { getAllTokenData } from 'utils/stacks';
import { API } from 'config/api';
import NftDetail from 'components/NftDetail';
import NftInformation from 'components/NftInformation';
import ModalPurchase from 'components/Modal/Purchase';
import ModalBid from 'components/Modal/PlaceABid';
import { AuthContext } from 'contexts/auth/auth.context';
import withSession from 'lib/session';
import { useHttp, useHttpBid } from 'lib/useHttp';
// import ErrorStatus from './status';
import ModalEditions from 'components/Modal/Editions';
import ModalSend from 'components/Modal/Send';
import ModalSell from 'components/Modal/Sell';
import ModalCancelSell from 'components/Modal/CancelSell';
import ModalCancelAuction from 'components/Modal/CancelAuction';
import { number } from 'utils/utility';
import { useAuthDispatch } from 'contexts/0Auth';
import axios from 'axios';

const NftPage = ({ data, access_token, user, token_id, collection }) => {
  const { nft, purchase, error } = data;
  const [token, setToken] = useState({});
  const { contract_token_id, name, description, id: nft_id, file, mint_transaction, auction, price_usd } = nft;
  const { data: unlockables } = useHttp(`${process.env.NEXT_PUBLIC_API_URL}/nft/${nft_id}/unlockables`, access_token);
  const { data: nfts } = useHttp(`${process.env.NEXT_PUBLIC_API_URL}/me/nonFungibleTokens`, access_token);
  const { data: wallets } = useHttp(`${process.env.NEXT_PUBLIC_API_URL}/me/wallets`, access_token);
  const { data: txns } = useHttp(`${process.env.NEXT_PUBLIC_API_URL}/nft/${nft_id}/transactions/pending`, access_token);

  // console.log('txns', txns);

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      if (typeof window !== 'undefined') {
        window.gtag('event', 'view_item', {
          currency: 'USD',
          value: number(price_usd),
          items: [
            {
              item_id: nft_id,
              item_name: name,
              currency: 'USD',
              price: number(price_usd),
              quantity: 1,
            },
          ],
        });
      }
    }
    return () => (isSubscribed = false);
  }, [nft_id, name, price_usd]);

  const [id, setId] = useState(-1);
  const [type, setType] = useState('');
  const [visible, setVisible] = useState(false);
  const [nftData, setNftData] = useState({});
  const [usdPurchaseData, setUsdPurchaseData] = useState();
  const router = useRouter();

  const pathname = router.asPath;

  const { goToOauth } = useAuthDispatch();

  const { authDispatch } = useContext(AuthContext);

  const { data: favorites } = useHttp(`${process.env.NEXT_PUBLIC_API_URL}/me/favorites`, access_token);
  const { data: bids } = useHttpBid(`${process.env.NEXT_PUBLIC_API_URL}/nft/${nft_id}/bids`, auction);
  const { data: history } = useHttpBid(`${process.env.NEXT_PUBLIC_API_URL}/nft/${nft_id}/history`, true);

  useEffect(() => {
    const contractName = mint_transaction?.smart_contract?.name;
    // console.log('contract:', contractName);
    if (nft?.contract_token_id) {
      getAllTokenData(nft?.contract_token_id, contractName).then((res) => {
        // console.log(res);
        setToken(res);
      });
    }
  }, [mint_transaction, nft]);

  const onGoToAuth = async () => {
    await axios.post('/api/current', { pathname });
    goToOauth();
  };

  const onOpenModal = async (type) => {
    if (user?.isLoggedIn) {
      // console.log('type', type);
      setType(type);
      setNftData({
        ...nft,
        owner: token.owner,
        forSale: token?.metaData?.['for-sale']?.value || false,
        priceSTX: token?.metaData?.['price']?.value,
        error: error,
      });
      setUsdPurchaseData(purchase);
      setId(contract_token_id);
      setVisible(true);
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      onGoToAuth();
    }
  };

  const onOpenModalDetail = async (values, type) => {
    if (user?.isLoggedIn) {
      setType(type);
      setNftData({
        ...nft,
        owner: token.owner,
        forSale: token?.metaData?.['for-sale']?.value || false,
        priceSTX: token?.metaData?.['price']?.value,
        error: error,
      });
      setUsdPurchaseData(purchase);
      setId(contract_token_id);
      setVisible(true);
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      onGoToAuth();
    }
  };

  const onOpenModalEditions = () => {
    setType('editions');
    setNftData({
      ...nft,
      owner: token.owner,
      forSale: token?.metaData?.['for-sale']?.value || false,
      priceSTX: token?.metaData?.['price']?.value,
      error: error,
    });
    setUsdPurchaseData(purchase);
    setId(contract_token_id);
    setVisible(true);
  };

  const onSubmit = (data) => {
    console.log(data);
  };

  const onButton = () => {
    setVisible(false);
    setId(-1);
    if (type === 'bid') {
      router.replace(router.asPath);
    }
  };
  const url = process.env.NEXT_PUBLIC_URL || 'https://staging.heylayer.com/';
  const descriptionAlt = `This NFT was minted on heylayer.com. Create and Sell NFTs on Bitcoin.`;
  const metaDescription = description ? `${description} - NFT on Bitcoin.` : descriptionAlt;
  const props = { visible, setVisible, setNftData, onSubmit, onButton, nftData, usdPurchaseData, access_token, token };

  const walletStx = wallets ? wallets.data?.find((el) => el.network === 'stacks') : {};

  return (
    <Box id="content">
      <NextSeo
        title={`${name}  - NFT Powered by Layer`}
        description={metaDescription}
        canonical={`${url}/nft/${nft_id}`}
        openGraph={{
          type: 'website',
          url: url,
          title: `${name}`,
          description: metaDescription,
          locale: 'en_EN',
          images: [
            {
              url: file?.thumbnail_http_url,
              width: 800,
              height: 600,
              alt: `${name}`,
            },
          ],
          site_name: 'heylayer.com',
        }}
        twitter={{
          handle: '@HeyLayer',
          site: 'heylayer.com',
          cardType: 'summary_large_image',
        }}
      />

      <>
        <NftDetail
          forSale={token?.metaData?.['for-sale']?.value || false}
          priceSTX={token?.metaData?.['price']?.value}
          token_id={token_id}
          user={user}
          nftData={data}
          onOpenModal={onOpenModal}
          onOpenModalEditions={onOpenModalEditions}
          favorites={favorites?.data || []}
          access_token={access_token}
          collection={collection}
          topBider={bids?.data[0] || null}
          mynfts={nfts?.data || []}
          txns={txns?.data || []}
        />
        <NftInformation
          nftData={data}
          collection={collection}
          bids={bids?.data || []}
          history={history?.data || []}
          currentUser={user}
          unlockables={unlockables?.data}
        />
        {type === 'purchase' && <ModalPurchase {...props} wallets={wallets?.data || []} />}
        {type === 'bid' && <ModalBid {...props} />}
        {type === 'editions' && <ModalEditions {...props} onOpenModal={onOpenModalDetail} />}
        {type === 'send' && <ModalSend {...props} wallet={walletStx || {}} owner={token?.owner} />}
        {type === 'sell' && (
          <ModalSell {...props} wallet={walletStx || {}} forSale={token?.metaData?.['for-sale']?.value || false} />
        )}
        {type === 'cancel' && (
          <ModalCancelSell
            {...props}
            forSale={token?.metaData?.['for-sale']?.value || false}
            priceSTX={token?.metaData?.['price']?.value}
          />
        )}
        {type === 'cancel-bid' && <ModalCancelAuction {...props} wallet={walletStx || {}} />}
      </>
    </Box>
  );
};

export const getServerSideProps = withSession(async function ({ req, params }) {
  const user = req.session.get('user');
  const access_token = user?.access_token || '';

  try {
    const { id } = params;
    const nftData = (await API.get(`/nft/${id}`, { responseType: 'json' })).data;
    const nft = JSON.parse(safeJsonStringify(nftData.data));
    let collection;
    if (!isEmpty(nft.non_fungible_token_collection)) {
      collection = (await API.get(`/collection/${nft.non_fungible_token_collection?.id}`, { responseType: 'json' }))
        .data;
    }
    return {
      props: {
        collection: collection?.data || {},
        token_id: nft?.contract_token_id || null,
        access_token,
        user: user || {},
        data: { nft, purchase: {}, error: '' },
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});

export default NftPage;
